import {IS_LOADING,IS_LOADED } from './actions'
export function isLoading(){
    return { type: IS_LOADING};
 }
 export function isLoaded(){
     return{type: IS_LOADED}
 }
 